import _objectSpread from "/codebuild/output/src267823822/src/package/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import e from "./isBrowser.js";
import r from "./getBaseUrl.js";
import t from "./getPathName.js";
export default (function () {
  var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : e() && window.location.href;
  var i;
  return i = "undefined" == typeof URL ? new URL(o).pathname.slice(1) : t(r(o)).slice(1), i.split("/").reduce(function (e, r, t) {
    return _objectSpread(_objectSpread({}, e), {}, {
      [t]: r
    });
  }, {});
});